import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function KnowledgeLevelsIcon({ className }: IconProps) {
  return (
    <svg
      width="82"
      height="80"
      viewBox="0 0 82 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1203_1398)">
        <path
          d="M76.0006 38.7559H5.99939C2.68602 38.7559 0 41.434 0 44.7376V74.0182C0 77.3218 2.68602 80 5.99939 80H76.0006C79.314 80 82 77.3218 82 74.0182V44.7376C82 41.434 79.314 38.7559 76.0006 38.7559Z"
          fill="#00416B"
        />
        <path
          d="M41.0127 80.0004C41.0127 80.0004 48.3985 77.5122 60.2964 77.5122C72.1944 77.5122 79.5802 80.0004 79.5802 80.0004C79.5802 80.0004 71.8919 72.6865 60.2964 72.6865C48.701 72.6865 41.0127 80.0004 41.0127 80.0004Z"
          fill="#DFE2E9"
        />
        <path
          d="M41.0127 80.0002V38.9823C41.0127 38.9823 59.3385 23.1733 79.5802 38.9823V80.0002C79.5802 80.0002 60.9518 66.4281 41.0127 80.0002Z"
          fill="#DFE2E9"
        />
        <path
          d="M50.5407 41.395C50.2382 41.395 49.9609 41.219 49.8601 40.9174C49.7088 40.5404 49.9105 40.1132 50.2886 39.9624C57.145 37.3485 63.9511 37.3485 70.505 39.9624C70.8831 40.1132 71.0596 40.5404 70.9083 40.9174C70.7571 41.2944 70.3286 41.4704 69.9505 41.3196C63.7494 38.8565 57.2963 38.8565 50.7928 41.3196C50.7171 41.3447 50.6163 41.3698 50.5407 41.3698V41.395Z"
          fill="#00416B"
        />
        <path
          d="M46.4323 49.9406C46.1802 49.9406 45.9282 49.8149 45.7769 49.5636C45.5752 49.2117 45.7013 48.7593 46.0542 48.5582C52.6838 44.9139 63.0188 41.9733 74.463 48.5582C74.816 48.7593 74.942 49.2117 74.7403 49.5636C74.5387 49.9155 74.0849 50.0411 73.732 49.8401C62.8676 43.5818 53.0619 46.3968 46.76 49.8401C46.6592 49.8903 46.5331 49.9406 46.4071 49.9406H46.4323Z"
          fill="#00416B"
        />
        <path
          d="M46.4323 56.5758C46.1802 56.5758 45.9282 56.4502 45.7769 56.1988C45.5752 55.847 45.7013 55.3946 46.0542 55.1935C52.6838 51.5491 63.0188 48.6085 74.463 55.1935C74.816 55.3946 74.942 55.847 74.7403 56.1988C74.5387 56.5507 74.0849 56.6764 73.732 56.4753C62.8676 50.2171 53.0619 53.032 46.76 56.4753C46.6592 56.5256 46.5331 56.5758 46.4071 56.5758H46.4323Z"
          fill="#00416B"
        />
        <path
          d="M46.4323 63.236C46.1802 63.236 45.9282 63.1103 45.7769 62.859C45.5752 62.5071 45.7013 62.0547 46.0542 61.8537C52.6838 58.2093 63.0188 55.2687 74.463 61.8537C74.816 62.0547 74.942 62.5071 74.7403 62.859C74.5387 63.2109 74.0849 63.3365 73.732 63.1355C62.8676 56.8772 53.0619 59.6922 46.76 63.1355C46.6592 63.1857 46.5331 63.236 46.4071 63.236H46.4323Z"
          fill="#00416B"
        />
        <path
          d="M46.4323 69.8713C46.1802 69.8713 45.9282 69.7456 45.7769 69.4943C45.5752 69.1424 45.7013 68.69 46.0542 68.4889C52.6838 64.8446 63.0188 61.9039 74.463 68.4889C74.816 68.69 74.942 69.1424 74.7403 69.4943C74.5387 69.8461 74.0849 69.9718 73.732 69.7707C62.8676 63.5125 53.0619 66.3274 46.76 69.7707C46.6592 69.821 46.5331 69.8713 46.4071 69.8713H46.4323Z"
          fill="#00416B"
        />
        <path
          d="M2.44531 80.0004C2.44531 80.0004 9.83111 77.5122 21.7291 77.5122C33.627 77.5122 41.0128 80.0004 41.0128 80.0004C41.0128 80.0004 33.3245 72.6865 21.7291 72.6865C10.1336 72.6865 2.44531 80.0004 2.44531 80.0004Z"
          fill="#B0B9CF"
        />
        <path
          d="M2.44531 80.0002V38.9823C2.44531 38.9823 20.7712 23.1733 41.0128 38.9823V80.0002C41.0128 80.0002 22.3844 66.4281 2.44531 80.0002Z"
          fill="#EAEDF8"
        />
        <path
          d="M11.9733 41.395C11.6708 41.395 11.3935 41.219 11.2927 40.9174C11.1414 40.5404 11.3431 40.1132 11.7212 39.9624C18.5777 37.3485 25.3837 37.3485 31.9376 39.9624C32.3158 40.1132 32.4922 40.5404 32.341 40.9174C32.1897 41.2944 31.7612 41.4704 31.3831 41.3196C25.182 38.8565 18.7289 38.8565 12.2254 41.3196C12.1497 41.3447 12.0489 41.3698 11.9733 41.3698V41.395Z"
          fill="#00C4B3"
        />
        <path
          d="M7.86492 49.9406C7.61284 49.9406 7.36077 49.8149 7.20952 49.5636C7.00786 49.2117 7.1339 48.7593 7.48681 48.5582C14.1164 44.9139 24.4515 41.9733 35.8957 48.5582C36.2486 48.7593 36.3746 49.2117 36.1729 49.5636C35.9713 49.9155 35.5175 50.0411 35.1646 49.8401C24.3002 43.5818 14.4945 46.3968 8.19262 49.8401C8.09179 49.8903 7.96575 49.9406 7.83971 49.9406H7.86492Z"
          fill="#00C4B3"
        />
        <path
          d="M7.86492 56.5758C7.61284 56.5758 7.36077 56.4502 7.20952 56.1988C7.00786 55.847 7.1339 55.3946 7.48681 55.1935C14.1164 51.5491 24.4515 48.6085 35.8957 55.1935C36.2486 55.3946 36.3746 55.847 36.1729 56.1988C35.9713 56.5507 35.5175 56.6764 35.1646 56.4753C24.3002 50.2171 14.4945 53.032 8.19262 56.4753C8.09179 56.5256 7.96575 56.5758 7.83971 56.5758H7.86492Z"
          fill="#00C4B3"
        />
        <path
          d="M7.86492 63.236C7.61284 63.236 7.36077 63.1103 7.20952 62.859C7.00786 62.5071 7.1339 62.0547 7.48681 61.8537C14.1164 58.2093 24.4515 55.2687 35.8957 61.8537C36.2486 62.0547 36.3746 62.5071 36.1729 62.859C35.9713 63.2109 35.5175 63.3365 35.1646 63.1355C24.3002 56.8772 14.4945 59.6922 8.19262 63.1355C8.09179 63.1857 7.96575 63.236 7.83971 63.236H7.86492Z"
          fill="#00C4B3"
        />
        <path
          d="M7.86492 69.8713C7.61284 69.8713 7.36077 69.7456 7.20952 69.4943C7.00786 69.1424 7.1339 68.69 7.48681 68.4889C14.1164 64.8446 24.4515 61.9039 35.8957 68.4889C36.2486 68.69 36.3746 69.1424 36.1729 69.4943C35.9713 69.8461 35.5175 69.9718 35.1646 69.7707C24.3002 63.5125 14.4945 66.3274 8.19262 69.7707C8.09179 69.821 7.96575 69.8713 7.83971 69.8713H7.86492Z"
          fill="#00C4B3"
        />
        <path
          d="M41.0127 80.0004C41.0127 80.0004 48.3985 77.5122 60.2964 77.5122C72.1944 77.5122 79.5802 80.0004 79.5802 80.0004C79.5802 80.0004 71.8919 72.6865 60.2964 72.6865C48.701 72.6865 41.0127 80.0004 41.0127 80.0004Z"
          fill="#B0B9CF"
        />
        <path
          d="M44.743 28.3001L36.6514 27.4959C36.4245 27.4959 36.248 27.2697 36.248 27.0435V26.5659H45.2471V27.8477C45.2471 28.1242 45.0203 28.3253 44.743 28.3001Z"
          fill="#00416B"
        />
        <path
          d="M44.743 30.2605L36.6514 29.4563C36.4245 29.4563 36.248 29.2301 36.248 29.0039V28.5766C36.248 28.3001 36.4749 28.0991 36.7522 28.1242L44.8438 28.9285C45.0707 28.9285 45.2471 29.1547 45.2471 29.3809V29.8081C45.2471 30.0846 45.0203 30.2857 44.743 30.2605Z"
          fill="#00416B"
        />
        <path
          d="M44.7932 31.8191H36.7016C36.4495 31.8191 36.2227 31.618 36.2227 31.3415V30.5121C36.2227 30.2357 36.4495 30.0346 36.7268 30.0597L44.8184 30.864C45.0453 30.864 45.2217 31.0902 45.2217 31.3164C45.2217 31.5929 45.0201 31.794 44.768 31.794"
          fill="#00416B"
        />
        <path
          d="M42.4747 33.9052H39.0465C38.6936 33.9052 38.3659 33.7544 38.139 33.5031L37.6097 32.925C37.4332 32.724 37.5845 32.4224 37.8365 32.4224H43.6595C43.9367 32.4224 44.0628 32.724 43.8863 32.925L43.357 33.5031C43.1301 33.7544 42.8024 33.9052 42.4495 33.9052"
          fill="#00416B"
        />
        <path
          d="M30.6265 14.5021C30.803 9.32459 35.0126 5.02676 40.2054 4.75029C46.0535 4.44869 50.8934 9.07325 50.8934 14.8288C50.8934 17.7946 49.6078 20.4336 47.5912 22.2935C46.6081 23.1732 46.0787 24.4298 46.0787 25.7368V25.8373C46.0787 26.34 45.6754 26.7421 45.1713 26.7421H36.3486C35.8445 26.7421 35.4412 26.34 35.4412 25.8373V25.7619C35.4412 24.455 34.9118 23.1983 33.9539 22.3186C31.8365 20.4085 30.5257 17.6187 30.6265 14.5021Z"
          fill="#EAEDF8"
        />
        <path
          d="M55.1533 15.1305H52.2292C52.0528 15.1305 51.9268 15.0049 51.9268 14.8289C51.9268 14.653 52.0528 14.5273 52.2292 14.5273H55.1533C55.3298 14.5273 55.4558 14.653 55.4558 14.8289C55.4558 15.0049 55.3298 15.1305 55.1533 15.1305Z"
          fill="#00C4B3"
        />
        <path
          d="M29.2656 15.1305H26.3416C26.1651 15.1305 26.0391 15.0049 26.0391 14.8289C26.0391 14.653 26.1651 14.5273 26.3416 14.5273H29.2656C29.4421 14.5273 29.5681 14.653 29.5681 14.8289C29.5681 15.0049 29.4421 15.1305 29.2656 15.1305Z"
          fill="#00C4B3"
        />
        <path
          d="M55.1532 15.2813H52.2291C51.977 15.2813 51.7754 15.0802 51.7754 14.8289C51.7754 14.5775 51.977 14.3765 52.2291 14.3765H55.1532C55.4053 14.3765 55.6069 14.5775 55.6069 14.8289C55.6069 15.0802 55.4053 15.2813 55.1532 15.2813Z"
          fill="#00C4B3"
        />
        <path
          d="M29.2655 15.2813H26.3414C26.0894 15.2813 25.8877 15.0802 25.8877 14.8289C25.8877 14.5775 26.0894 14.3765 26.3414 14.3765H29.2655C29.5176 14.3765 29.7192 14.5775 29.7192 14.8289C29.7192 15.0802 29.5176 15.2813 29.2655 15.2813Z"
          fill="#00C4B3"
        />
        <path
          d="M50.6916 9.55056C50.5403 9.55056 50.3891 9.47516 50.2883 9.32435C50.1622 9.09815 50.2378 8.82168 50.4647 8.69602L53.0107 7.23827C53.2375 7.11261 53.5148 7.18801 53.6409 7.41421C53.7669 7.64041 53.6913 7.91688 53.4644 8.04255L50.9184 9.50029C50.9184 9.50029 50.7672 9.55056 50.6916 9.55056Z"
          fill="#00C4B3"
        />
        <path
          d="M28.2824 22.4695C28.1312 22.4695 27.9799 22.3941 27.8791 22.2433C27.753 22.0171 27.8287 21.7406 28.0555 21.615L30.6015 20.1572C30.8284 20.0316 31.1056 20.107 31.2317 20.3332C31.3577 20.5594 31.2821 20.8358 31.0552 20.9615L28.5093 22.4192C28.5093 22.4192 28.358 22.4695 28.2824 22.4695Z"
          fill="#00C4B3"
        />
        <path
          d="M46.507 5.35347C46.507 5.35347 46.3558 5.35347 46.2801 5.3032C46.0533 5.17753 45.9776 4.90106 46.1037 4.67486L47.5657 2.13638C47.6918 1.91017 47.969 1.83477 48.1959 1.96044C48.4228 2.08611 48.4984 2.36258 48.3724 2.58878L46.9103 5.12726C46.8347 5.27807 46.6835 5.35347 46.507 5.35347Z"
          fill="#00C4B3"
        />
        <path
          d="M40.7604 3.8203C40.5083 3.8203 40.3066 3.61923 40.3066 3.36789V0.452403C40.3066 0.201068 40.5083 0 40.7604 0C41.0125 0 41.2141 0.201068 41.2141 0.452403V3.36789C41.2141 3.61923 41.0125 3.8203 40.7604 3.8203Z"
          fill="#00C4B3"
        />
        <path
          d="M35.013 5.35347C34.8617 5.35347 34.7105 5.27807 34.6097 5.12726L33.1476 2.58878C33.0216 2.36258 33.0972 2.08611 33.3241 1.96044C33.551 1.83477 33.8282 1.91017 33.9543 2.13638L35.4163 4.67486C35.5423 4.90106 35.4667 5.17753 35.2399 5.3032C35.1642 5.35347 35.0886 5.35347 35.013 5.35347Z"
          fill="#00C4B3"
        />
        <path
          d="M30.803 9.55056C30.803 9.55056 30.6517 9.55056 30.5761 9.50029L28.0301 8.04255C27.8033 7.91688 27.7276 7.64041 27.8537 7.41421C27.9797 7.18801 28.257 7.11261 28.4839 7.23827L31.0298 8.69602C31.2567 8.82168 31.3323 9.09815 31.2063 9.32435C31.1307 9.47516 30.9794 9.55056 30.803 9.55056Z"
          fill="#00C4B3"
        />
        <path
          d="M53.2375 22.4695C53.2375 22.4695 53.0863 22.4695 53.0107 22.4192L50.4647 20.9615C50.2378 20.8358 50.1622 20.5594 50.2883 20.3332C50.4143 20.107 50.6916 20.0316 50.9184 20.1572L53.4644 21.615C53.6913 21.7406 53.7669 22.0171 53.6409 22.2433C53.5652 22.3941 53.414 22.4695 53.2375 22.4695Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1203_1398">
          <rect width="82" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
